// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8458dcaf","455":"6f7d7059","555":"4d2f344e","602":"69ea27e6","722":"9b90c538","808":"5638ef99","977":"e626628f"}[chunkId] + ".chunk.js";
};